const zIndex = {
    inputShadow: 1,
    inputLabel: 2,
    inputRightElement: 3,
    navBar: 5,
    storiesButtons: 10,
    storiesProgress: 11,
    scrollableLayout: 1000,
    scrollableOverlay: 999,
    floatingLayoutTop: 500,
    modalIndex: 2000,
    floatingLayoutBottom: 1002,
    loaderLayout: 3000,
    toast: 10001,
    overlay: 10000,
};
export { zIndex };
